/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */

export type UserType = typeof UserType[keyof typeof UserType];


export const UserType = {
  User: 'User',
  WebUser: 'WebUser',
  ExternalServiceUser: 'ExternalServiceUser',
  ServiceUser: 'ServiceUser',
  DatabaseRole: 'DatabaseRole',
  UserGroup: 'UserGroup',
} as const;
